module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "lista_solicitud_por_aprobar",
    staticClass: "box position-relative"
  }, [_c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis contratos")])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    key: "list-solicitudes",
    staticClass: "position-relative"
  }, [(_vm.mostrarConfirmacionFirmar) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('confirmar-accion-overlay', {
    ref: "firmarContrato",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionFirmar = false
      },
      "do": function($event) {
        return _vm.generarToken()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea firmar su contrato?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("cargando...")] : [_vm._v("Firmar")]], 2)])], 1) : _vm._e(), (_vm.mostrarModalConfirmacionToken) ? _c('div', {
    key: "modal-posicion-token",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [_c('span', [_vm._v("Le ha llegado el token de validacion a su correo: ")]), _c('strong', [_vm._v(_vm._s(_vm.correoServer))])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v("Dispone de " + _vm._s(_vm.cuentaRegresiva) + " para utilizar el token enviado.")]), _c('div', {
    staticClass: "contenedor-datos fdc"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Token"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tokenCliente),
      expression: "tokenCliente"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tokenCliente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tokenCliente = $event.target.value
      }
    }
  })])])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardarGenerarToken
    }
  }, [_c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.cerrarModalConfirmacionToken
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])]) : _vm._e(), _c('div', [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading && _vm.lista.length > 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Duración")]), _c('th', [_vm._v("Creación")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Contrato: ' + o.id
      }
    }, [(!o.indeterminado) ? _c('span', [_vm._v(_vm._s(o.fechaInicio) + " - " + _vm._s(o.fechaFin))]) : _c('span', [_vm._v("Indeterminado")])])]), _c('td', [_vm._v(_vm._s(o.creado))]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "contenedor-acciones fdc"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.verContrato(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])]), (!o.firmado) ? [(!o.primera_visualizacion) ? _c('div', {
      staticClass: "hint--top d-flex",
      attrs: {
        "aria-label": "Debe visualizar su contrato antes de firmarlo"
      }
    }, [_c('button', {
      staticClass: "button is-small",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _c('span', [_vm._v("Firmar")])])]) : _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmacionFirmar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _c('span', [_vm._v("Firmar")])])] : _c('div', {
      staticClass: "firmado fs-12"
    }, [_c('span', [_vm._v("Firmado: ")]), _c('span', [_vm._v(_vm._s(o.fechaFirma))])])], 2)])])
  }), 0)], 1) : _vm._e(), (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron contratos")])]) : _vm._e()], 1)])])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70bcf60c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Mis_Contratos.vue
// module id = 903
// module chunks = 0